import AccessDenied from "@/components/AccessDenied.vue";
import MainLayout from "@/layouts/user/main";
import EmployerFormPage from "@/pages/EmployerFormPage.vue";
import HealthInsuranceForm from "@/pages/HealthInsuranceForm.vue";
import LogoutPage from "@/pages/LogoutPage.vue";
import PaymentMethodPage from "@/pages/PaymentMethodPage.vue";
import ThankYouPage from "@/pages/ThankYouPage.vue";
export default [
  {
    path:'/',
    component:MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: { name: 'EmployerFormPage' }
      },
      {
        path: '/employer-form',
        name: 'EmployerFormPage',
        component:EmployerFormPage
      },
      {
        path:'health-insurance',
        name:'HealthInsurance',
        component:HealthInsuranceForm
      },
      {
        path:'add-payment-method',
        name:'PaymentMethodPage',
        component:PaymentMethodPage
      },
      {
        path:'logout',
        name:'Logout',
        component:LogoutPage
      },
      {
        path:'thank-you',
        name:"ThankYouPage",
        component:ThankYouPage
      }
    ],
  },
  {
    path: '/access-denied',
    name: 'AccessDenied',
    component: AccessDenied,
    meta: { requiresAuth: false }
  }
]